import { useAction, useAtom } from '@reatom/npm-react'
import { useMount } from 'react-use'
import styled, { css } from 'styled-components'
import { useMemo } from 'use-memo-one'

import { AsyncStateN } from '@blade/std-lib'
import { mediaMaxTablet } from '@root/shared/ui-kit'

import { reatomMfaSetup } from '../../atoms/reatom-setup-mfa'

import { SetupOtpConfirm } from './setup-otp-confirm'
import { SetupOtpHeading } from './setup-otp-heading'
import { SetupOtpInstructions } from './setup-otp-instructions'
import { SetupOtpQr } from './setup-otp-qr'

export type SetupOtpMode = 'instructions' | 'qr' | 'confirm'

type SetupOtpProps = {
  onBack: () => void
  mode: SetupOtpMode
  setMode: (mode: SetupOtpMode) => void
}

export const SetupOtp: React.FC<SetupOtpProps> = ({
  onBack,
  mode,
  setMode,
}) => {
  // eslint-disable-next-line @reatom/unit-naming-rule
  const model = useMemo(() => reatomMfaSetup(), [])

  const createOtp = useAction(model.createOtp.createOtpAction)
  const [createOtpState] = useAtom(model.createOtp.createOtpRequestState)

  useMount(createOtp)

  const renderContent = () => {
    if (mode === 'qr' && AsyncStateN.isSuccess(createOtpState)) {
      return (
        <SetupOtpQr
          otpUrl={createOtpState.value.otpUrl}
          onModeChange={setMode}
        />
      )
    }

    if (mode === 'confirm') {
      return <SetupOtpConfirm onClose={onBack} model={model} />
    }

    return (
      <SetupOtpInstructions
        model={model.createOtp}
        onShowQr={() => setMode('qr')}
        onContinue={() => setMode('confirm')}
      />
    )
  }

  return (
    <Root>
      <SetupOtpHeading />
      {renderContent()}
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-template-rows: auto minmax(0, 1fr);
  overflow: auto;

  width: 440px;
  padding-block: 20px 24px;
  place-self: center;

  ${mediaMaxTablet(css`
    width: 100%;
    padding-inline: 20px;
  `)}
`
